/* eslint-disable */
import { Button } from '@synergy-marine-group/synergy-ui';
import { Field, FieldArray } from 'formik';
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { orderBy, set } from 'lodash';
import { Chip, Select } from '@material-ui/core';
import polygon from '../../images/icons/polygon.svg';
import joinedVesselCloseIcon from '../../images/icons/close.svg';
import getCurrencyList from '../vendor/queries/getCurrency';
import formatDropdownOptions from '../../utils/formatDropdownOptions';
import ExpenseFieldForm from './ExpenseFieldForm';
import PPEExpenseFieldForm from './PPEFieldForm';
import InputFieldComponent from '../common/FormComponents/InputFieldComponent';
import PartialSearchFieldComponent from '../common/FormComponents/PartialSearchFieldComponent';
import DropdownFieldComponent from '../common/FormComponents/DropdownFieldComponent';
import AdhocItemForm from './adhocItemForm';
import showAlert from '../../utils/alert';
import { useSelector } from 'react-redux';
import VesselAdhocPPE from './VesselAdhocPPE';
import { formatCrewDisplayName, getSapBPNumber, buildCrewSelectValue } from '../../utils/formatCrewDisplay';
import { enrichCrewListWithSapBP } from '../../utils/enrichCrewWithSapBP';

const checkCrewError = ({ touched, errors, fieldName, index }) => {
  if (touched?.[index]?.[fieldName] && errors?.[index]?.[fieldName]) {
    return errors?.[index]?.[fieldName];
  }
  return '';
};

const checkDisable = (crewList, isCrewPageFlag) => {
  if (!crewList || crewList.length === 0) return false;
  const last = crewList[crewList.length - 1];
  if (!last) return false;
  if (isCrewPageFlag) {
    return !last?.crewCode || !last?.firstName;
  }
  return !last?.plannedVesselId;
};

const NULL_GUID = '00000000-0000-0000-0000-000000000000';

const isNullGuid = (g) => !g || g === NULL_GUID;

const CrewForm = ({ values, dataObj, mode,
  errors, touched, setFieldValue, expenseitemsData, vesselList,
  expenseCategoryList,
  savedaccountCode,
  setSavedAccountCode,
  restoredPpeCategoryDetails,
  setRestoredPpeCategoryDetails, defaultCrewData, expenseItemList,setDefaultCrewData,
  companyId, setcreatedAccountCode,selectedDefaultCrewData }) => {
  const [Crewindex, setCrewindex] = useState(null);
  const [openCrew, setopenCrew] = useState(true);
  const [airfareOpen, setairfareOpen] = useState(false);
  const [airfareOpenValue, setairfareOpenValue] = useState(null);
  const [airfareStatuses, setairfareStatuses] = useState([]);
  const [crewData, setCrewData] = useState();
  const [focusCrewRowIndex, setFocusCrewRowIndex] = useState(null);
  const [vesselData, setVesselData] = useState();
  const [vesselIndex, setVesselIndex] = useState();
  /** Row indices where Joined Vessel UI stays open after clear (empty dropdown). */
  const [joinedVesselSlotVisible, setJoinedVesselSlotVisible] = useState(() => new Set());
  const [airstatusSection, setAirStatusSection] = useState(true);
  const oldVendorId = dataObj?.vendorId;
  const OldExpenseCategoryId = dataObj?.expenseCategoryId;
  const enrichedEditPoRef = useRef(null);
  const category = expenseCategoryList?.find(
    ({ expenseCategoryID }) => expenseCategoryID === values?.expenseCategoryId
);
  const sapPoNumberPosition = values?.sapPoNumberPosition || dataObj?.sapPoNumberPosition || '-';
  const normalizedSapPoNumberPosition = sapPoNumberPosition.toLowerCase().replace(/[^a-z]/g, '');
  const showLineItemSapPoNumber = normalizedSapPoNumberPosition.includes('lineitem');
// const isCrewPage = useSelector((state) => state.pageHandler.pageSetter.isCrewPage);
const [isCrewPage, setisCrewPage] = useState();
  const emptyCrewObj = {
    crewId: isCrewPage ? '' : selectedDefaultCrewData?.uuid || '',
    amount: '',
    expenseLineItemId: '',
    id: '',
    plannedVesselId: '',
    crewCode: isCrewPage ? '' : selectedDefaultCrewData?.crewCode || '',
    sapBPNumber: isCrewPage ? '' : getSapBPNumber(selectedDefaultCrewData) || '',
    crewRank: '',
    rankCategory: '',
    rankId: '',
    gender: '',
    ppeCategoryDetails: '',
    ppeDeliveryRemarks: '',
    categoryDetails: category?.expenseFields?.map((item) => ({ key: item.key, label: item.label, value: '' })),
    airfareStatus: airfareOpenValue,
    plannedVesselRevisionId:'',
    joinedVesselId: null,
    joinedVesselRevisionId: NULL_GUID,
    joinedVesselName: '',
    joinedVesselStatus: ''
  };

  const hasJoinedVesselValue = (crew) => {
    const name = crew?.joinedVesselName && String(crew.joinedVesselName).trim();
    const id = crew?.joinedVesselId != null && crew.joinedVesselId !== '' && !isNullGuid(crew.joinedVesselId);
    const rev = crew?.joinedVesselRevisionId && !isNullGuid(crew.joinedVesselRevisionId);
    return !!(name || id || rev);
  };

  const markJoinedVesselSlotVisible = (index) => {
    setJoinedVesselSlotVisible((prev) => new Set(prev).add(index));
  };

  const clearJoinedVesselAtIndex = (index) => {
    setFieldValue(`purchaseOrderCrew[${index}].joinedVesselId`, null);
    setFieldValue(`purchaseOrderCrew[${index}].joinedVesselRevisionId`, NULL_GUID);
    setFieldValue(`purchaseOrderCrew[${index}].joinedVesselName`, '');
    setFieldValue(`purchaseOrderCrew[${index}].joinedVesselStatus`, '');
    markJoinedVesselSlotVisible(index);
  };

  const joinedVesselActionsDisabled = (crew) => crew?.isShortClosed
    || crew?.airfareStatus === 1
    || crew?.airfareStatus === 2
    || crew?.serviceStatus
    || crew?.invoiceStatus?.toLowerCase().includes('payment')
    || crew?.invoiceStatus?.toLowerCase().includes('voucher')
    || crew?.invoiceStatus?.toLowerCase().includes('transferred');

  const shouldShowVesselDropdown = (mode, crew) => {
    const status = crew?.plannedVesselStatus;
    const plannedVesselId = crew?.plannedVesselId;
  
    // Add mode → always show dropdown
    if (mode === "add") return true;
  
    if (mode === "edit") {
      // If vessel not selected in past → show dropdown
      if (!plannedVesselId) return true;
  
      // If status absent → show dropdown
      if (!status) return true;
  
      // Editable statuses → show dropdown
      if (status === "Active" || status === "TakeoverPending" || status === "ActivationPending") return true;
  
      // Otherwise → show label
      return false;
    }
  
    return false;
  };

  const { data: currencies } = getCurrencyList();
  const currencyList = orderBy(formatDropdownOptions(currencies?.data, 'code', 'id'), 'code');
  const resetFields = (rowIndex) => {
    if (rowIndex == null || rowIndex === '') return;
    setFieldValue(`purchaseOrderCrew[${rowIndex}].firstName`, '');
    setFieldValue(`purchaseOrderCrew[${rowIndex}].plannedVesselId`, '');
    setFieldValue(`purchaseOrderCrew[${rowIndex}].lastName`, '');
    setFieldValue(`purchaseOrderCrew[${rowIndex}].crewCode`, '');
    setFieldValue(`purchaseOrderCrew[${rowIndex}].sapBPNumber`, '');
    setFieldValue(`purchaseOrderCrew[${rowIndex}].expenseLineItemId`, '');
    setFieldValue(`purchaseOrderCrew[${rowIndex}].expenseLineItem`, '');
    setFieldValue(`purchaseOrderCrew[${rowIndex}].accountCode`, '');
    setFieldValue(`purchaseOrderCrew[${rowIndex}].age`, '');
    setFieldValue(`purchaseOrderCrew[${rowIndex}].phoneNumber`, '');
    setFieldValue(`purchaseOrderCrew[${rowIndex}].placeOfBirth`, '');
    setFieldValue(`purchaseOrderCrew[${rowIndex}].amount`, '');
    setFieldValue(`purchaseOrderCrew[${rowIndex}].crewId`, '');
    setFieldValue(`purchaseOrderCrew[${rowIndex}].rankName`, '');
    setFieldValue(`purchaseOrderCrew[${rowIndex}].rankId`, '');
    setFieldValue(`purchaseOrderCrew[${rowIndex}].gender`, '');
    setFieldValue(`purchaseOrderCrew[${rowIndex}].rankCategory`, '');
    setFieldValue(`purchaseOrderCrew[${rowIndex}].categoryDetails`, '');
    setFieldValue(`purchaseOrderCrew[${rowIndex}].ppeCategoryDetails`, '');
    setFieldValue(`purchaseOrderCrew[${rowIndex}].ppeDeliveryRemarks`, '');
  };
 
  useEffect(() => {
    if (vesselData && defaultCrewData) {
      if(!isCrewPage){
      const matchedVessel = vesselList?.find(item => item.value === vesselData);
      const purchseCrewDetails = values.purchaseOrderCrew;
      const { uuid, firstName, lastName, rankName, crewCode, rankId, gender, rankCategory, age, dateOfBirth } = defaultCrewData;
      const sapBPNumber = getSapBPNumber(defaultCrewData);
        const finalArray = purchseCrewDetails?.map((item, index) =>
          index === vesselIndex
            ? {
                firstName,
                lastName,
                crewId: uuid,
                id: item?.id,
                age,
                categoryDetails: category?.expenseFields?.map((item)=>({key: item.key, label: item.label, value:'' })),
                ppeCategoryDetails: purchseCrewDetails?.[vesselIndex]?.ppeCategoryDetails,
                ppeDeliveryRemarks: purchseCrewDetails?.[vesselIndex]?.ppeDeliveryRemarks,
                expenseLineItemId: purchseCrewDetails?.[vesselIndex]?.expenseLineItemId,
                amount: purchseCrewDetails?.[vesselIndex]?.amount,
                plannedVesselId: purchseCrewDetails?.[vesselIndex]?.plannedVesselId,
                crewCode: crewCode,
                sapBPNumber,
                rankName,
                gender,
                rankId,
                rankCategory,
                airfareStatus: purchseCrewDetails?.[vesselIndex]?.airfareStatus || airfareOpenValue,
                dateOfBirth,
                imo: matchedVessel?.imoNumber,
                vesselCode: matchedVessel?.vesselCode,
                vesselName: matchedVessel?.name,
                sapVesselCompanyCode: matchedVessel?.sapVesselCompanyCode || '',
                plannedVesselRevisionId: purchseCrewDetails?.[vesselIndex]?.plannedVesselRevisionId
              }
            : {...item
            } 
        );
        setFieldValue('purchaseOrderCrew', finalArray);
    }
  }
  }, [vesselData]);
  useEffect(() => {
  if (savedaccountCode) {
    setSavedAccountCode(null)
  }
  }, [values?.vendorId, values?.expenseCategoryId, companyId]);
  // useEffect(() => {
  //   if (values?.vendorId !== oldVendorId || values?.expenseCategoryId !== OldExpenseCategoryId) {
  //     setCrewData(null);
  //   }
  // }, [values?.vendorId, values?.expenseCategoryId, crewData]);
  useEffect(() => {
const raw = localStorage.getItem('isPageHandler');
if (!raw) return;
let pageType;
try {
pageType = JSON.parse(raw);
} catch (e) {
pageType = raw;
}
setisCrewPage(pageType === 'crew');
}, []);

  useEffect(() => {
    if (mode !== 'edit' || !isCrewPage || !dataObj?.id || !values?.purchaseOrderCrew?.length) {
      return;
    }
    if (enrichedEditPoRef.current === dataObj.id) {
      return;
    }

    const needsEnrichment = values.purchaseOrderCrew.some(
      (crew) => crew?.crewCode && !getSapBPNumber(crew)
    );
    if (!needsEnrichment) {
      enrichedEditPoRef.current = dataObj.id;
      return;
    }

    let cancelled = false;
    (async () => {
      const enrichedCrew = await enrichCrewListWithSapBP(values.purchaseOrderCrew, {
        companyId,
        expenseCategoryID: category?.expenseCategoryID || values?.expenseCategoryId || ''
      });
      if (cancelled) return;
      enrichedEditPoRef.current = dataObj.id;
      setFieldValue('purchaseOrderCrew', enrichedCrew);
    })();

    return () => {
      cancelled = true;
    };
  }, [
    mode,
    isCrewPage,
    dataObj?.id,
    companyId,
    category?.expenseCategoryID,
    values?.expenseCategoryId
  ]);


    useEffect(() => {
      if (!values || !Array.isArray(values?.purchaseOrderCrew)) return;
    const matchedVessel = vesselList?.find(item => item.value == vesselData);
    if (isCrewPage) {
      if (!crewData || Crewindex == null) {
        return;
      }
      const trainingId = expenseCategoryList?.find(({ label }) => label === 'Training')?.expenseCategoryID;
      if (values?.expenseCategoryId === trainingId) {
        if(crewData?.value === defaultCrewData.uuid)
        {
          showAlert("You are not allowed to select 'Common Crew' under the Training category.", "error");          
          return;
        }
      }
      const purchseCrewDetails = values?.purchaseOrderCrew||[];
      const { value, firstName, lastName, rankName, crewCode, rankId,
      gender, rankCategory, age, dateOfBirth, positionName, sapBPNumber } = crewData || {};
      const resolvedSapBPNumber = sapBPNumber || getSapBPNumber(crewData);
      const finalArray = purchseCrewDetails?.map((item, index) =>
        index === Crewindex
          ? {
              firstName,
              lastName,
              crewId: value,
              id: item?.id,
              age,
                categoryDetails: category?.expenseFields?.map((item)=>({key: item.key, label: item.label, value:'' })),
                ppeCategoryDetails: purchseCrewDetails?.[Crewindex]?.ppeCategoryDetails,
                ppeDeliveryRemarks: purchseCrewDetails?.[Crewindex]?.ppeDeliveryRemarks,
                expenseLineItemId: purchseCrewDetails?.[Crewindex]?.expenseLineItemId,
              amount: purchseCrewDetails?.[Crewindex]?.amount,
                plannedVesselId: purchseCrewDetails?.[Crewindex]?.plannedVesselId,
                crewCode: crewCode,
                sapBPNumber: resolvedSapBPNumber,
              rankName,
              gender,
              rankId,
              rankCategory,
                airfareStatus: purchseCrewDetails?.[Crewindex]?.airfareStatus || airfareOpenValue,
              dateOfBirth,
              positionName,
              plannedVesselRevisionId: purchseCrewDetails?.[Crewindex]?.plannedVesselRevisionId,
            }
          : {
            ...item
          }
      );
      setFieldValue('purchaseOrderCrew', finalArray);
    }
  }, [crewData, vesselData, isCrewPage]);

  useEffect(() => {
  //if expenseCategoryid is airfare then open airfare form
  //find expenseCategoryId of AIRFARE
  const airfareId = expenseCategoryList?.find(({ label }) => label === 'Airfare')?.expenseCategoryID;
  if (values?.expenseCategoryId === airfareId) {
      setairfareOpen(true);
      setairfareOpenValue(0);
      if(mode === 'edit') {
        const airfareStatus =[{value: 0, label: 'Normal'}, {value: 1, label: 'Cancel'}, {value: 2, label: 'Reissue'}]
        setairfareStatuses(airfareStatus);
      }
      else {
        const airfareStatus =[{value: 0, label: 'Normal'}]
        setairfareStatuses(airfareStatus);
      }
    } else {
      setairfareOpen(false);
      setairfareOpenValue(null);
    }
  }, [values?.expenseCategoryId]);

  const isbtndisabled = useMemo(() => checkDisable(values?.purchaseOrderCrew, isCrewPage), [values?.purchaseOrderCrew, isCrewPage]);

const getAccountCode = (id) => {
  if(!savedaccountCode){
  const crewItem = values?.purchaseOrderCrew?.[id];
  if (!crewItem) return null;
  const expenseLineItemID = crewItem?.expenseLineItemId;
  const matchedItem = expenseitemsData?.find(
    (item) => item.expenseLineItemID === expenseLineItemID
  );
  if (matchedItem?.companyExpenseAccountCodeList?.length > 0) {
   const companyMatch = matchedItem.companyExpenseAccountCodeList.find(
      (entry) =>String(entry.companyId) === String(companyId)
    );
    if (companyMatch) {
      return companyMatch.accountCodeName;
    }
  }
  setcreatedAccountCode(matchedItem?.accountCode || crewItem?.accountCode)

  return matchedItem?.accountCode || crewItem?.accountCode;
}
else{
 if( savedaccountCode[id]?.expenseLineItemId ==values?.purchaseOrderCrew?.[id].expenseLineItemId)
 {
  return savedaccountCode[id]?.accountCode
 }
 else{
  const crewItem = values?.purchaseOrderCrew?.[id];
  if (!crewItem) return null;
  const expenseLineItemID = crewItem?.expenseLineItemId;
  const matchedItem = expenseitemsData?.find(
    (item) => item.expenseLineItemID === expenseLineItemID
  );
  if (matchedItem?.companyExpenseAccountCodeList?.length > 0) {
   const companyMatch = matchedItem.companyExpenseAccountCodeList.find(
      (entry) =>String(entry.companyId) === String(companyId)
    );  
    if (companyMatch) {
      const updated = [...savedaccountCode];
      updated[id] = {
        ...updated[id],
        expenseLineItemId: expenseLineItemID,
        accountCode:companyMatch.accountCodeName
      };
      setSavedAccountCode(updated);
      return companyMatch.accountCodeName;
    }
  }
  const updated = [...savedaccountCode];
  updated[id] = {
    ...updated[id],
    expenseLineItemId: expenseLineItemID,
    accountCode: matchedItem?.accountCode
  };
  setSavedAccountCode(updated);
  setcreatedAccountCode(matchedItem?.accountCode)

  return matchedItem?.accountCode; 
 }
}
};

const getCurrency = () => {
  const currency = currencyList?.find((item) => item.id === values?.currencyId)?.label
  return currency
  };

const calculateTotalAmount = () => {
  let totalAmount = 0;
  if(values?.purchaseOrderCrew?.length  === 0)
  {
    totalAmount = null;
  }
  {values?.purchaseOrderCrew?.map((item) => {
    if (item?.amount !== '' && item?.amount !== null) {
      if(item?.isShortClosed !== true) {
        if(item?.airfareStatus !== 1) {
          totalAmount += Number(item?.amount);
        } else {
          totalAmount -= Number(item?.amount);
        }
      }
    }
  })}
  totalAmount = Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(totalAmount);
  return totalAmount
};

  useEffect(() => {
    if (values?.purchaseOrderCrew) {
      dataObj?.purchaseOrderCrew?.map((item, index) => {
        values.purchaseOrderCrew[index].amount = item.amount;
      });
    }
  }, []);

  return (
    <>
      <FieldArray
        name="purchaseOrderCrew"
        render={({ push, remove }) => {
          return (
            <>
              <div
                onClick={() => { return setopenCrew(!openCrew);}}
                className="flex flex-row place-content-between mb-4  mt-4 bg-secondary-500 p-1 px-2.5 rounded-md  cursor-pointer"
              >
                <div className="text-base font-muli text-white-light font-bold">
                {isCrewPage ? 'Add Crew' : 'Add Line Item'}
                 </div>
            <img src={polygon} alt="polygon" className={`${!openCrew ? 'transform -rotate-90' : ''} w-6`} />
              </div>
              {openCrew && (
              <div>
              {calculateTotalAmount() && (
              <div className="flex justify-end p-4 ">
                <div className="text-right">
                  <span className="pr-2 font-bold text-xl">Total:</span>
                </div>
                <div className="text-right text-secondary-900">
                  <span className=" font-bold text-xl">{getCurrency()} {' '}</span>
                  <span className=" font-bold text-xl">
                    {calculateTotalAmount()}
                  </span>
                </div>
              </div>
              )}
                {values?.purchaseOrderCrew && values?.purchaseOrderCrew?.length > 0 ? (
                  values.purchaseOrderCrew.map((crew, index) => {
                    const showDropdown = shouldShowVesselDropdown(mode, crew);
                   return (
                    <>
                      <div className="p-5 mb-4" style={{ border: '2px solid #EEEEEE', borderRadius: '10px' }}>
                      {(crew.firstName && isCrewPage) && (
                          <>
                            <div className="mt-2  flex flex-row justify-between mb-4">
                                    <div className="w-full md:w-1/4">
                                      <span className="text-md"> Crew Name :</span>
                                      <span className="font-bold text-md">
                                        {formatCrewDisplayName(crew)}
                                      </span>

                                    </div>
                                    {category?.label === 'PPE' && (
                                    <div className="w-full md:w-1/6 text-center">
                                      <span className="text-md"> Gender :</span>
                                      <span className="font-bold text-md">{crew.gender || '-'}</span>
                                    </div>
                                    )}
                                    <div className="w-full md:w-1/6 text-center">
                                      <span className="text-md"> Age :</span>
                                      <span className="font-bold text-md">
                                        {crew.age || '-'}
                                      </span>
                                    </div>
                                    <div className="w-full md:w-1/4 text-center">
                                      <span className="text-md"> SapBpNumber :</span>
                                      <span className="font-bold text-md">{getSapBPNumber(crew) || '-'}</span>
                                    </div>

                                <div className="w-full md:w-1/4 text-center">
                                <span className="text-md">Rank :</span>
                                  <span className="font-bold text-md">{crew?.rankName || '-'}</span>
                                </div>
                                <div className="w-full md:w-1/4 text-center">
                                <span className="text-md">Position :</span>
                                  <span className="font-bold text-md">{crew?.positionName || '-'}</span>
                                </div>
                               {crew?.isShortClosed && (<div className="w-full md:w-1/3 text-right">
                                <Chip variant="outlined" className="text-white-light" label='Short Closed' />
                                </div>
                                )}
                           {airfareOpen && (
                           <Select
                              type="button"
                              name={`purchaseOrderCrew[${index}].airfareStatus`}
                              className="pl-6 text-right border-2 border-secondary-500 rounded-full"
                              disabled={crew?.isShortClosed
                                || crew?.invoiceStatus?.toLowerCase().includes('payment')
                                || crew?.invoiceStatus?.toLowerCase().includes('voucher')
                                || crew?.serviceStatus 
                                || crew?.invoiceStatus?.toLowerCase().includes('transferred')}
                              value={crew?.airfareStatus || 0}
                              onChange={(value) => {
                                if(mode === 'edit') {
                                let statuses=[];
                                values?.purchaseOrderCrew?.map((item) => {
                                  if (item.crewCode === crew.crewCode && item?.expenseLineItemId === crew?.expenseLineItemId) {
                                      statuses.push(item.airfareStatus);
                                  }
                                });
                                if(!statuses.includes(value?.target?.value)) {
                                  // reissue happens only if cancel is there
                                // if(value?.target?.value === 2) {
                                //   if(!statuses.includes(1)) {
                                //     return
                                //   }
                                // }
                                push({
                                  crewCode: crew.crewCode,
                                  firstName: crew?.firstName,
                                  lastName: crew?.lastName,
                                  rankName: crew?.rankName,
                                  age: crew?.age,
                                  crewId: crew?.crewId,
                                  rankId: crew?.rankId,
                                  gender: crew?.gender,
                                  rankCategory: crew?.rankCategory,
                                  plannedVesselId: crew?.plannedVesselId,
                                  amount: '',
                                  expenseLineItemId: crew?.expenseLineItemId,
                                  expenseLineItem: crew?.expenseLineItem,
                                  // set categoryDetails if value.target.value is 1
                                  categoryDetails: value?.target?.value === 1 ? crew?.categoryDetails : '',
                                  accountCode: crew.accountCode,
                                  airfareStatus: value?.target?.value,
                                  dateOfBirth: crew?.dateOfBirth
                                }); 
                              }
                              // empty satauses
                              statuses=[];
                              }
                              else {
                                setFieldValue(`purchaseOrderCrew[${index}].airfareStatus`, 0);
                              }
                              }}
                            >
                              {airfareStatuses.map((item) => (
                                <option value={item.value} className="p-4 hover:font-bold cursor-pointer">{item.label}</option>
                              ))}
                            </Select>
                            )}
                            </div>
                            </>
                          )}
                          {(!isCrewPage) && (crew.vesselName || crew.plannedVesselName) && (
                            <div className="mt-2  flex flex-row justify-between mb-4">
                                    <div className="w-full md:w-1/4">
                                      <span className="text-md"> Vessel Name :</span>
                                      <span className="font-bold text-md">{crew.vesselName?crew.vesselName:crew.plannedVesselName || '-'}</span>
                                    </div>
                                    <div className="w-full md:w-1/4">
                                      <span className="text-md"> Vessel Code :</span>
                                      <span className="font-bold text-md">{crew.vesselCode?crew.vesselCode:crew.plannedVesselCode || '-'}</span>
                                    </div>
                                  
                                    <div className="w-full md:w-1/4">
                                      <span className="text-md"> IMO :</span>
                                      <span className="font-bold text-md">
                                        {crew.imo?crew.imo:crew.plannedVesselImo || '-'}
                                      </span>
                                    </div>
                                      <div className="w-full md:w-1/4">
                                        <span className="text-md"> SAP Vessel Company Code :</span>
                                        <span className="font-bold text-md">
                                          {crew?.sapVesselCompanyCode
                                            || vesselList?.find(
                                              (v) => v?.value === crew?.plannedVesselRevisionId
                                                || String(v?.id) === String(crew?.plannedVesselId)
                                            )?.sapVesselCompanyCode
                                            || '-'}
                                        </span>
                                       </div>
                               {crew?.isShortClosed && (<div className="w-full md:w-1/3 text-right">
                                <Chip variant="outlined" className="text-white-light" label='Short Closed' />
                                </div>
                                )}
                            </div>
                        
                          )}
                        <div className="grid grid-cols-3 gap-6 p-1">
                        {isCrewPage && ( <div className="required-field">
                            <Field
                              name={`purchaseOrderCrew[${index}].crewCode`}
                              component={PartialSearchFieldComponent}
                              className="w-full"
                              id="number"
                              size="medium"
                              variant="text"
                              rounded
                              resetFields={resetFields}
                              index={index}
                              isClearable
                              category={category}
                              companyId={companyId}
                              setCrewData={setCrewData}
                              setCrewindex={setCrewindex}
                              autoFocus={focusCrewRowIndex === index}
                              autoComplete="off"
                              label="Crew Code"
                              isDisabled={crew?.isShortClosed
                                ||(category?.label?.toLowerCase() == 'training' &&
                                (values?.poStatus ? (values?.poStatus!== 'Draft' && index < dataObj?.purchaseOrderCrew?.length) : null)
                                )
                                || crew?.airfareStatus === 1
                                || crew?.airfareStatus === 2
                                || crew?.serviceStatus 
                                || crew?.invoiceStatus?.toLowerCase().includes('payment')
                                || crew?.invoiceStatus?.toLowerCase().includes('voucher')
                                || crew?.invoiceStatus?.toLowerCase().includes('transferred')}
                              value={buildCrewSelectValue(crew)}
                              placeholder="Search by Crew Code or SAP BP Number (Min 4 chars)"
                               />
                            <div className="error text-xs">
                              {checkCrewError({
                                touched: touched?.purchaseOrderCrew,
                                errors: errors?.purchaseOrderCrew,
                                index,
                                fieldName: 'crewCode'
                              })}
                              {values?.purchaseOrderCrew?.[index]?.crewCode &&
                                touched?.purchaseOrderCrew?.[index]?.firstName &&
                                errors?.purchaseOrderCrew?.[index]?.firstName}
                            </div>
                          </div>)}
                          {!isCrewPage && (
                            (showDropdown) ? (
                              <div className="required-field">
                                <Field
                                  name={`purchaseOrderCrew[${index}].plannedVesselId`}
                                  component={DropdownFieldComponent}
                                  setChangedValue={(item, ind) => {
                                    setRestoredPpeCategoryDetails({
                                      restoredPpeDetails: [],
                                      plannedVesselId: '',
                                    });
                                    setVesselData(item);
                                    setVesselIndex(index);
                                  }}
                                  special={
                                    vesselList?.find(
                                      (v) =>
                                        v.value ===
                                        values?.purchaseOrderCrew?.[index]?.plannedVesselRevisionId
                                    ) || null
                                  }
                                  customOnChange={(option, form) => {
                                    form.setFieldValue(
                                      `purchaseOrderCrew[${index}].plannedVesselId`,
                                      option?.id || ''
                                    );
                                    form.setFieldValue(
                                      `purchaseOrderCrew[${index}].plannedVesselRevisionId`,
                                      option?.value || ''
                                    );
                                    // Set vessel display fields
                                    form.setFieldValue(
                                      `purchaseOrderCrew[${index}].vesselName`,
                                      option?.name || ''
                                    );
                                    form.setFieldValue(
                                      `purchaseOrderCrew[${index}].vesselCode`,
                                      option?.vesselCode || ''
                                    );
                                    form.setFieldValue(
                                      `purchaseOrderCrew[${index}].imo`,
                                      option?.imoNumber || ''
                                    );
                                    form.setFieldValue(
                                      `purchaseOrderCrew[${index}].sapVesselCompanyCode`,
                                      option?.sapVesselCompanyCode || ''
                                    );
                                  }}
                                  className="w-full"
                                  options={vesselList}
                                  isDisabled={
                                    crew?.isShortClosed ||
                                    crew?.airfareStatus === 1 ||
                                    crew?.airfareStatus === 2 ||
                                    crew?.serviceStatus ||
                                    crew?.invoiceStatus?.toLowerCase().includes('payment') ||
                                    crew?.invoiceStatus?.toLowerCase().includes('voucher') ||
                                    crew?.invoiceStatus?.toLowerCase().includes('transferred')
                                  }
                                  rounded
                                  id="select1"
                                  type="text"
                                  placeholder=""
                                  label="Vessel"
                                />

                                <div className="error text-xs">
                                  {checkCrewError({
                                    touched: touched?.purchaseOrderCrew,
                                    errors: errors?.purchaseOrderCrew,
                                    index,
                                    fieldName: 'plannedVesselId',
                                  })}
                                </div>
                              </div>
                            ) : (
                              <div className="flex flex-col mb-2">
                                <label className="font-medium text-sm">Vessel</label>
                                <div className="py-2 text-gray-100 font-semibold">
                                  {values?.purchaseOrderCrew?.[index]?.plannedVesselName || '-'}
                                </div>
                              </div>
                            )
                          )}

                          <div className="required-field">
                          <Field
                            name={`purchaseOrderCrew[${index}].expenseLineItemId`}
                            component={DropdownFieldComponent}
                            className="w-full"
                            special={{label: crew?.expenseLineItem}}
                            options={expenseitemsData}
                            setFieldsNull={
                              isCrewPage
                                ? [`purchaseOrderCrew[${index}].amount`,`purchaseOrderCrew[${index}].plannedVesselId`, `purchaseOrderCrew[${index}].categoryDetails`]
                                : [`purchaseOrderCrew[${index}].amount`, `purchaseOrderCrew[${index}].categoryDetails`]
                            }
                            isDisabled={crew?.isShortClosed
                            || crew?.airfareStatus === 1
                            || crew?.airfareStatus === 2
                            || crew?.serviceStatus                               
                            || crew?.invoiceStatus?.toLowerCase().includes('payment')
                            || crew?.invoiceStatus?.toLowerCase().includes('voucher')
                            || crew?.invoiceStatus?.toLowerCase().includes('transferred')}
                            rounded
                            id="select1"
                            type="text"
                            placeholder=""
                            label="Expense Line Item" />
                            <div className="error text-xs">
                              {checkCrewError({
                                touched: touched?.purchaseOrderCrew,
                                errors: errors?.purchaseOrderCrew,
                                index,
                                fieldName: 'expenseLineItemId'
                              })}
                            </div>
                            </div>
                          <Field
                            name={`purchaseOrderCrew[${index}].accountCode`}                            
                            component={InputFieldComponent}
                            className="w-full"
                            id="number"
                            size="medium"
                            variant="text"
                            rounded
                            disabled
                            value={getAccountCode(index) || ''}
                            label="Account Code" />
                          {showLineItemSapPoNumber && index < (dataObj?.purchaseOrderCrew?.length || 0) && (
                            <Field
                              name={`purchaseOrderCrew[${index}].sapPoNumber`}
                              component={InputFieldComponent}
                              className="w-full"
                              id="sapPoNumber"
                              size="medium"
                              variant="text"
                              rounded
                              disabled
                              value={values?.purchaseOrderCrew?.[index]?.sapPoNumber || '-'}
                              label="SAP PO Number"
                            />
                          )}
                          {mode === 'edit' && index < (dataObj?.purchaseOrderCrew?.length || 0) && (
                            <Field
                              name={`purchaseOrderCrew[${index}].sapSequenceNumber`}
                              component={InputFieldComponent}
                              className="w-full"
                              id="sapSequenceNumber"
                              size="medium"
                              variant="text"
                              rounded
                              disabled
                              value={(values?.purchaseOrderCrew?.[index]?.sapSequenceNumber ?? '') !== ''
                                ? values?.purchaseOrderCrew?.[index]?.sapSequenceNumber
                                : '-'}
                              label="SAP Sequence Number"
                            />
                          )}
                          {isCrewPage && (
                            showDropdown ? (
                              <div className={`${category?.label === "PPE" ? "required-field" : ""}`}>
                                <Field
                                  name={`purchaseOrderCrew[${index}].plannedVesselId`}
                                  component={DropdownFieldComponent}
                                  customOnChange={(option, form) => {
                                    form.setFieldValue(
                                      `purchaseOrderCrew[${index}].plannedVesselId`,
                                      option?.id || ""
                                    );
                                    form.setFieldValue(
                                      `purchaseOrderCrew[${index}].plannedVesselRevisionId`,
                                      option?.value || ""
                                    );
                                  }}
                                  setChangedValue={(item, ind) => {
                                    setRestoredPpeCategoryDetails({
                                      restoredPpeDetails: [],
                                      plannedVesselId: "",
                                    });
                                    setVesselData(item);
                                    setVesselIndex(index);
                                  }}
                                  special={
                                    vesselList?.find(
                                      (v) =>
                                        v.value ===
                                        values?.purchaseOrderCrew?.[index]?.plannedVesselRevisionId
                                    ) || null
                                  }
                                  className="w-full"
                                  options={vesselList}
                                  isDisabled={
                                    crew?.isShortClosed ||
                                    crew?.airfareStatus === 1 ||
                                    crew?.airfareStatus === 2 ||
                                    crew?.serviceStatus ||
                                    crew?.invoiceStatus?.toLowerCase().includes("payment") ||
                                    crew?.invoiceStatus?.toLowerCase().includes("voucher") ||
                                    crew?.invoiceStatus?.toLowerCase().includes("transferred")
                                  }
                                  rounded
                                  id="select1"
                                  type="text"
                                  placeholder=""
                                  label="Planned Vessel"
                                  isClearable={category?.label === "PPE" ? false : true}
                                />

                                <div className="error text-xs">
                                  {checkCrewError({
                                    touched: touched?.purchaseOrderCrew,
                                    errors: errors?.purchaseOrderCrew,
                                    index,
                                    fieldName: "plannedVesselId",
                                  })}
                                </div>
                              </div>
                            ) : (
                              <div className="flex flex-col mb-2">
                                <label className="font-medium text-sm">Planned Vessel</label>
                                <div className="py-2 text-gray-100 font-semibold">
                                  {values?.purchaseOrderCrew?.[index]?.plannedVesselName || "-"}
                                </div>
                              </div>
                            )
                          )}

                          <div className="required-field">
                          <Field
                              name={`purchaseOrderCrew[${index}].amount`}
                              component={InputFieldComponent}
                              className="w-full"
                              // max two decimals
                              onInput={(e) => {
                                // airfare changes pending
                                // if(crew?.airfareStatus === 1) {
                                //   values?.purchaseOrderCrew?.map((item, i) => {
                                //     if( crew?.crewId === item?.crewId && item?.airfareStatus === 0) {
                                //       if(e.target.value > item?.amount) {
                                //         e.target.value = item?.amount;
                                //       }
                                //     }
                                //   }) 
                                // }
                                const value = e.target.value;
                                const regex = new RegExp(/^\d{1,20}(\.\d{1,2})?$/);
                                if (!regex.test(value)) {
                                  e.target.value = value.slice(0, -1);
                                }
                              }}
                              // value to be set to 2 decimals on all categories
                              // onBlur={(e) => {
                              //   const value = e.target.value;
                              //   const regex = new RegExp(/^\d{1,20}(\.\d{1,2})?$/);
                              //   if (regex.test(value)) {
                              //     e.target.value = parseFloat(value).toFixed(2);
                              //   }
                              // }}
                              id="number"
                              size="medium"
                              disabled={crew?.isShortClosed
                                || category?.label === 'PPE'
                                || category?.label === 'Vessel PPE'
                                || crew?.serviceStatus 
                                || crew?.invoiceStatus?.toLowerCase().includes('payment')
                                || crew?.invoiceStatus?.toLowerCase().includes('voucher')
                                || crew?.invoiceStatus?.toLowerCase().includes('transferred')}
                              onWheel={(e) => e.target.blur()}
                              variant="number"
                              rounded
                              autoComplete="off"
                              placeholder="Enter amount"
                              label="Amount"
                             />
                            <div className="error text-xs">
                              {checkCrewError({
                                touched: touched?.purchaseOrderCrew,
                                errors: errors?.purchaseOrderCrew,
                                index,
                                fieldName: 'amount'
                              })}
                            </div>
                          </div>
                        {isCrewPage && mode === 'edit' && (hasJoinedVesselValue(crew) || joinedVesselSlotVisible.has(index)) && (
                          <div className="required-field">
                            <div className="text-sm text-gray-500">Joined Vessel</div>
                            {hasJoinedVesselValue(crew) ? (
                              <div
                                className="flex h-10 w-full items-center gap-3 rounded-lg border border-gray-200 bg-gray-100 px-4 shadow-sm joined-vesselfield"
                              >
                                <div className="min-w-0 flex-1">
                                  <div className="truncate font-muli text-sm text-gray-500">
                                    {crew.joinedVesselName || '-'}
                                  </div>
                                </div>
                                <button
                                  type="button"
                                  className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-md bg-gray-600 hover:bg-gray-700 disabled:opacity-50 joinded-close-btn"
                                  onClick={() => clearJoinedVesselAtIndex(index)}
                                  disabled={joinedVesselActionsDisabled(crew)}
                                  aria-label="Clear joined vessel"
                                >
                                  <img
                                    src={joinedVesselCloseIcon}
                                    alt=""
                                    className="pointer-events-none h-3.5 w-3.5"
                                    style={{ filter: 'brightness(0) invert(1)' }}
                                  />
                                </button>
                              </div>
                            ) : (
                              <div
                                className="h-12 rounded-lg border border-gray-200 bg-gray-100 px-4 shadow-sm joined-vessel-cleared"
                                aria-label="Joined vessel cleared"
                              />
                            )}
                          </div>
                        )}
                        </div>
                    
                        {(category?.label === 'PPE' || category?.label === 'Vessel PPE' ) && (
                           <div>
                  {isCrewPage ? (
  <>
    <PPEExpenseFieldForm
      setFieldValue={setFieldValue}
      index={index}
      crew={crew}
      isCrewPage={isCrewPage}
      values={values}
      errors={errors}
      touched={touched}
      category={category}
      id={values?.expenseCategoryId}
      expenseCategoryList={expenseCategoryList}
      restoredPpeCategoryDetails={restoredPpeCategoryDetails}
    />
    <AdhocItemForm
      setFieldValue={setFieldValue}
      index={index}
      crew={crew}
      values={values}
      isCrewPage={isCrewPage}
      errors={errors}
      touched={touched}
      category={category}
      id={values?.expenseCategoryId}
      expenseCategoryList={expenseCategoryList}
      restoredPpeCategoryDetails={restoredPpeCategoryDetails}
    />
  </>
) : (
  <VesselAdhocPPE
    setFieldValue={setFieldValue}
    index={index}
    crew={crew}
    mode={mode}
    values={values}
    errors={errors}
    isCrewPage={isCrewPage}
    touched={touched}
    category={category}
    id={values?.expenseCategoryId}
    expenseCategoryList={expenseCategoryList}
    restoredPpeCategoryDetails={restoredPpeCategoryDetails}
  />
)}

                      </div>
                        )}
                        <ExpenseFieldForm
                          index={index}
                          crew={crew}
                          values={values}
                          checkIn={crew?.categoryDetails?.[0]?.value}
                          checkOut={crew?.categoryDetails?.[1]?.value}
                          category={category}
                          id={values?.expenseCategoryId}
                          expenseCategoryList={expenseCategoryList}
                        />
                           
                        <div className="text-right pt-4">
                          <Button
                            type="button"
                            className="rounded-md"
                            onClick={() => {
                              if(mode!=='add')
                                {
                                  if(savedaccountCode)
                                    {
                                  setSavedAccountCode((prev) => {
                                    const updated = [...prev];
                                    updated.splice(index, 1);
                                    return updated;
                                  });
                                  }
                                }
                              setRestoredPpeCategoryDetails({restoredPpeDetails:[],plannedVesselId:''});
                              
                              remove(index);
                              
                            } }
                            size="large"
                            variant={ (crew?.isShortClosed
                              || crew?.serviceStatus 
                              || (values?.poStatus ? (values?.poStatus!== 'Draft' && index < dataObj?.purchaseOrderCrew?.length) : null)
                              || crew?.invoiceStatus?.toLowerCase().includes('payment')
                              || crew?.invoiceStatus?.toLowerCase().includes('voucher')
                              || crew?.invoiceStatus?.toLowerCase().includes('transferred')) ? "disabled" : "outlined"}
                            disabled={crew?.isShortClosed
                              || crew?.serviceStatus 
                              || (values?.poStatus ? (values?.poStatus!== 'Draft' && index < dataObj?.purchaseOrderCrew?.length) : null)
                              || crew?.invoiceStatus?.toLowerCase().includes('payment')
                              || crew?.invoiceStatus?.toLowerCase().includes('voucher')
                              || crew?.invoiceStatus?.toLowerCase().includes('transferred')}
                          >
                            delete
                          </Button>
                        
                        </div>
                      </div>
                    </>
                  )
                  }
                )) : (
                 <div/>
                )}
              </div>
              )}
              
              {openCrew && (
              <div className="pt-2 pb-2">
              <Button
                  type="button"
                  className="rounded-md w-full w-100 max-w-full bg-amber-100"
                  onClick={() => {
                   if(!selectedDefaultCrewData?.crewCode)
                   {
                    setDefaultCrewData(null)
                   }else{
                    setDefaultCrewData(selectedDefaultCrewData)
                   }
                   if(mode!=='add')
                   {
                   if(savedaccountCode)
                   {
                    setSavedAccountCode((prev) => [...prev, emptyCrewObj]);
                   }     
                   }
                    const newRowIndex = values?.purchaseOrderCrew?.length ?? 0;
                    push(emptyCrewObj);
                    setFocusCrewRowIndex(newRowIndex);
                  }}
                  disabled={isbtndisabled}
                  hidden={(category?.label === 'PPE' || category?.label === 'Vessel PPE' )&& values?.purchaseOrderCrew.length > 0}
                  size="large"
                  variant="filled"
                >
                  {!isCrewPage ? 'Add Item' : 'Add crew'}
                </Button>
              </div>
              )}
               {airfareOpen && values?.purchaseOrderCrew.length >0 && ( 
                    <>
                    <div
                      onClick={() => { return setAirStatusSection(!airstatusSection);}}
                      className="flex flex-row place-content-between mb-4  mt-4 bg-secondary-500 p-1 px-2.5 rounded-md  cursor-pointer"
                    >                      <div className="text-base font-muli text-white-light font-bold">Airfare Details</div>
                  <img src={polygon} alt="polygon" className={`${!airstatusSection ? 'transform -rotate-90' : ''} w-6`} />
                    </div>
                    {airstatusSection && (
                      <>
                   <div className=" text-gray-500 p-4 text-md border-b-2 p-2 border-primary-100 mt-4 mb-2 rounded-t-sm flex flex-row justify-between capitalize">
                   <div className="w-full md:w-1/5 font-bold">
                              crew name
                            </div>
                            <div className="w-full md:w-1/5 font-bold">
                              Crew code
                            </div>
                            <div className="w-full md:w-1/5 font-bold">
                              Expense item
                            </div>
                            <div className="w-full md:w-1/5 font-bold">
                              Amount
                            </div>
        
                            <div className="w-full md:w-1/5 font-bold">
                              Status
                            </div>
                          </div>
                          {values?.purchaseOrderCrew?.map((crew, index) => (
                            <>
                            {crew?.crewCode && !crew?.isShortClosed && (
                          <div className=" flex flex-row justify-between p-4">
                         <div className="w-full md:w-1/5 bold">
                                {crew?.firstName} {crew?.lastName}
                              </div>
                              <div className="w-full md:w-1/5">
                              {crew?.crewCode}
                              </div>
                              <div className="w-full md:w-1/5">
                                {expenseitemsData?.find((item) => item?.expenseLineItemID === crew?.expenseLineItemId)?.expenseLineItem}
                              </div>
                              <div className="w-full md:w-1/5">
                                {crew?.amount && (
                                  <>
                                  {currencies?.data?.find((item) => item?.id === values?.currencyId)?.code}{' '}
                                  {crew?.airfareStatus === 1 ? '-' : ''}
                                  {Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(crew?.amount)}
                                  </>
                                )}
                              </div>
                              <div className="w-full md:w-1/5 bold">
                               <Chip 
                               variant='outlined'
                               color={crew?.airfareStatus === 0 ? 'primary' : crew?.airfareStatus === 1 ? 'secondary' : crew?.airfareStatus === 2 ? 'primary' : 'primary'}
                               label= {crew?.airfareStatus === 0 ? 'Normal' : crew?.airfareStatus === 1 ? 'Cancelled' : crew?.airfareStatus === 2 ? 'Reissued' : 'Normal'} />
                              </div>
                            </div>
                            )}
                            </>
                          ))}
                          </>
                          )}
                            </>
                  )}
            </>
            
          );
        }}
      />
    </>
  );
};

export default CrewForm;
